export const functionIsTrue = (fn: Function) => {
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            if (fn()) {
                clearInterval(interval);
                resolve(true);
            }
        }, 50);
    });
};
